import React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { get } from "lodash";
import { mainMenu } from "@qlik/qlik/src/lib/menu";
import { toKebabCase } from "@qlik/qlik/src/lib/utils";
import LinkWithDescription from "@qlik/qlik/src/components/Header/Sub_Menu_Components/Link_With_Description";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";

/**
 * SubmenuLayoutFour renders the right hand side of a main menu drop down, with
 * left: two columns of LinkWithDescription[], right: one column of LinkWithDescription[]
 * e.g. product > all products
 */
const SubmenuLayoutFour = ({ data: subItems, layoutType, layoutId, className = "", deviceType = "desktop" }) => {
    const allowedLayoutMap = get(mainMenu, `[${layoutType}]`);
    const allowedComponents = Object.keys(allowedLayoutMap);

    const layoutClass = toKebabCase(layoutType);
    return (
        <div
            className={`submenu-level-3 submenu--${layoutClass} xl:gap-15 xl:py-14.75`}
            data-parent={`${layoutClass}-${layoutId}`}
            data-device={`${deviceType}`}
        >
            <div className="max-xl:mb-15 xl:flex-[0_0_570px]">
                <div>
                    <p
                        className="text-md font-bold leading-none tracking-normal mb-5 pb-3.5 border-b border-b-gray/25"
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(subItems?.[0]?.title) }}
                    />
                    {subItems?.[0] && (
                        <ul className={`grid gap-x-15 gap-y-7.5 mt-5 grid-cols-1 lg:grid-cols-2 `}>
                            {subItems?.[0].subItems?.map((subItem) => (
                                <li key={subItem.id}>
                                    <LinkWithDescription data={subItem} />
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
            <div className="xl:flex-[0_0_180px]">
                <div className="max-xl:gap-15 flex flex-col gap-10">
                    <div>
                        <p
                            className="text-md font-bold leading-none tracking-normal mb-5 pb-3.5 border-b border-b-gray/25"
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(subItems?.[1]?.title) }}
                        />
                        {subItems?.[1] && (
                            <ul className={`grid gap-3.75 mt-5 grid-cols-1 `}>
                                {subItems?.[1]?.subItems?.map((subItem) => (
                                    <li key={subItem.id}>
                                        <LinkWithDescription data={subItem} />
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <div>
                        <p className="text-md font-bold leading-none tracking-normal mb-5 pb-3.5 border-b border-b-gray/25">
                            {subItems?.[2]?.title}
                        </p>
                        {subItems?.[2] && (
                            <ul className={`grid gap-3.75 mt-5 grid-cols-1 `}>
                                {subItems?.[2]?.subItems?.map((subItem) => (
                                    <li key={subItem.id}>
                                        <LinkWithDescription data={subItem} />
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubmenuLayoutFour;
